import styled from '@emotion/styled';

export const StyledIndexNumber = styled.span`
  color: var(--primary-color);
  margin-right: 0.25rem;
`;
